export default {
    topics: [
        {
            title: ' DictionaryCheck ',
            href: 'sm-report-DictionaryCheck.html',
            attributes: { 'data-id': 'sm-report-DictionaryCheck' },
            menu: { hasChildren: false },
            tocID: 'sm-report-DictionaryCheck-d66e1140',
            topics: [],
        },
        {
            title: ' DisplayDescriptiveAnalysis ',
            href: 'sm-report-DisplayDescriptiveAnalysis.html',
            attributes: { 'data-id': 'sm-report-DisplayDescriptiveAnalysis' },
            menu: { hasChildren: false },
            tocID: 'sm-report-DisplayDescriptiveAnalysis-d66e1148',
            topics: [],
        },
        {
            title: ' DisplayDescriptiveAnalysisEx ',
            href: 'sm-report-DisplayDescriptiveAnalysisEx.html',
            attributes: { 'data-id': 'sm-report-DisplayDescriptiveAnalysisEx' },
            menu: { hasChildren: false },
            tocID: 'sm-report-DisplayDescriptiveAnalysisEx-d66e1156',
            topics: [],
        },
        {
            title: ' ExecuteTransientQuery ',
            href: 'sm-report-ExecuteTransientQuery.html',
            attributes: { 'data-id': 'sm-report-ExecuteTransientQuery' },
            menu: { hasChildren: false },
            tocID: 'sm-report-ExecuteTransientQuery-d66e1164',
            topics: [],
        },
        {
            title: ' Export ',
            href: 'sm-report-Export.html',
            attributes: { 'data-id': 'sm-report-Export' },
            menu: { hasChildren: false },
            tocID: 'sm-report-Export-d66e1172',
            topics: [],
        },
        {
            title: ' ExportDescriptiveAnalysis ',
            href: 'sm-report-ExportDescriptiveAnalysis.html',
            attributes: { 'data-id': 'sm-report-ExportDescriptiveAnalysis' },
            menu: { hasChildren: false },
            tocID: 'sm-report-ExportDescriptiveAnalysis-d66e1180',
            topics: [],
        },
        {
            title: ' GenerateAnalysisWidget ',
            href: 'sm-report-GenerateAnalysisWidget.html',
            attributes: { 'data-id': 'sm-report-GenerateAnalysisWidget' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GenerateAnalysisWidget-d66e1188',
            topics: [],
        },
        {
            title: ' GenerateAndSaveReport ',
            href: 'sm-report-GenerateAndSaveReport.html',
            attributes: { 'data-id': 'sm-report-GenerateAndSaveReport' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GenerateAndSaveReport-d66e1196',
            topics: [],
        },
        {
            title: ' GenerateFlatReport ',
            href: 'sm-report-GenerateFlatReport.html',
            attributes: { 'data-id': 'sm-report-GenerateFlatReport' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GenerateFlatReport-d66e1204',
            topics: [],
        },
        {
            title: ' GetAvailableReports ',
            href: 'sm-report-GetAvailableReports.html',
            attributes: { 'data-id': 'sm-report-GetAvailableReports' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GetAvailableReports-d66e1212',
            topics: [],
        },
        {
            title: ' GetAvailableReportsEx ',
            href: 'sm-report-GetAvailableReportsEx.html',
            attributes: { 'data-id': 'sm-report-GetAvailableReportsEx' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GetAvailableReportsEx-d66e1221',
            topics: [],
        },
        {
            title: ' GetDescriptiveAnalysisData ',
            href: 'sm-report-GetDescriptiveAnalysisData.html',
            attributes: { 'data-id': 'sm-report-GetDescriptiveAnalysisData' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GetDescriptiveAnalysisData-d66e1229',
            topics: [],
        },
        {
            title: ' GetReportList ',
            href: 'sm-report-GetReportList.html',
            attributes: { 'data-id': 'sm-report-GetReportList' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GetReportList-d66e1237',
            topics: [],
        },
        {
            title: ' GetUsedLanguagesEnum ',
            href: 'sm-report-GetUsedLanguagesEnum.html',
            attributes: { 'data-id': 'sm-report-GetUsedLanguagesEnum' },
            menu: { hasChildren: false },
            tocID: 'sm-report-GetUsedLanguagesEnum-d66e1245',
            topics: [],
        },
        {
            title: ' Publish ',
            href: 'sm-report-Publish.html',
            attributes: { 'data-id': 'sm-report-Publish' },
            menu: { hasChildren: false },
            tocID: 'sm-report-Publish-d66e1253',
            topics: [],
        },
        {
            title: ' RegisterTransientSchema ',
            href: 'sm-report-RegisterTransientSchema.html',
            attributes: { 'data-id': 'sm-report-RegisterTransientSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-report-RegisterTransientSchema-d66e1261',
            topics: [],
        },
        {
            title: ' Save ',
            href: 'sm-report-Save.html',
            attributes: { 'data-id': 'sm-report-Save' },
            menu: { hasChildren: false },
            tocID: 'sm-report-Save-d66e1269',
            topics: [],
        },
        {
            title: ' exportSaved ',
            href: 'sm-report-exportSaved.html',
            attributes: { 'data-id': 'sm-report-exportSaved' },
            menu: { hasChildren: false },
            tocID: 'sm-report-exportSaved-d66e1277',
            topics: [],
        },
    ],
};

